import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Fab,
  IconButton,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  addNewTipologiaStrumentazione,
  deleteTipologiaStrumentazione,
  getAttrezzature,
  getTipologiaStrumentazione,
  updateAttrezzatureLocale,
} from '../../../utils/api/locali_e_attrezzature_api';
import SpinnerComponent from '../../../components/SpinnerComponent';
import ReactTable from 'react-table';
import ActionButton from '../../../components/ActionButton';
import {
  Add,
  DeleteForeverOutlined,
  Done,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import TipologiaStrumentazioneModal, {
  labelTipologia,
} from '../components/TipologiaStrumentazioneModal';
import TwoActionsAlertDialog from '../../../components/TwoActionsAlertDialog';
import { UNSAVED_CHANGES_CLOSE_MESSAGE } from '../../../utils/messages';
import { reportApiError, reportError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  centeredCellContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: '20px 10px',
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    overflowY: 'auto',
    width: '90%',
    maxWidth: '960px',
  },
  modalTitle: {
    marginTop: theme.spacing(1),
  },
  spanTitle: {
    backgroundColor: theme.palette.grey[300],
    padding: '4px 8px',
    borderRadius: '8px',
    fontWeight: 600,
  },
  topButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    gap: theme.spacing(1),
    width: '90%',
  },
  buttonWrapper: {
    width: '90%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

/**
 * Comparable snapshot of the rows, used to tell whether anything still differs
 * from what was loaded. Position in the array carries the row order, so a
 * reorder shows up as a difference.
 *
 * Keep this a serialised value rather than a copy of the rows: the cell editors
 * assign onto the row objects in place, so any baseline still holding
 * references to them - a shallow [...records] included - would be mutated along
 * with the live rows and always compare equal. Quantita is normalised to a
 * string because the loaded value is a number while the text field writes a
 * string.
 */
const snapshotRecords = (records) =>
  JSON.stringify(
    records.map((record) => [
      record.id ?? null,
      record.tipologiaStrumentazioneId ?? null,
      String(record.nome ?? ''),
      String(record.quantita ?? ''),
    ]),
  );

class ModalSelezioneAttrezzatura extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      openAddTipologiaModal: false,
      openRemoveTipologiaModal: false,
      currentTipologiaValue: null,
      selectedTipologiaToRemove: null,
      successfulSave: false,
      records: [],
      editMode: false,
      tipologiaList: [],
      newTipologia: '',
      isButtonRequestPressed: false,
      pristineRecords: snapshotRecords([]),
      isCloseConfirmOpen: false,
    };
  }

  /**
   * Compared against the loaded rows rather than latched on the first edit, so
   * adding a row and removing it again counts as no change.
   */
  hasUnsavedChanges = () =>
    snapshotRecords(this.state.records) !== this.state.pristineRecords;

  /**
   * The rows live only in this modal's state - nothing is lifted to the parent -
   * so closing without saving destroys them. Warn before that happens.
   */
  requestClose = () => {
    if (this.hasUnsavedChanges()) {
      this.setState({ isCloseConfirmOpen: true });
      return;
    }
    this.props.onClose();
  };

  confirmDiscardAndClose = () => {
    this.setState({ isCloseConfirmOpen: false });
    this.props.onClose();
  };

  cancelClose = () => {
    this.setState({ isCloseConfirmOpen: false });
  };

  componentDidMount() {
    this.getAttrezzaturaData();
  }

  saveData = () => {
    let array = [...this.state.records];
    let body = {
      manualeId: this.props.manualeId,
      localeId: this.props.selectedLocale.id,
      attrezzature: array,
    };
    this.setState({
      isButtonRequestPressed: true,
    });
    updateAttrezzatureLocale(body)
      .then(() => {
        return getAttrezzature(
          this.props.manualeId,
          this.props.selectedLocale.id,
          0,
          10000,
          'id',
        );
      })
      .then((attrezzatureAggiornate) => {
        this.setState({
          records: attrezzatureAggiornate,
          successfulSave: true,
          isButtonRequestPressed: false,
          pristineRecords: snapshotRecords(attrezzatureAggiornate),
        });
      })
      .catch((error) => {
        reportApiError(error);
        this.setState({
          isButtonRequestPressed: false,
        });
      });
  };

  findTipologiaId = (data) => {
    let arrayOfTipologia = [...this.state.tipologiaList];
    let stuff = arrayOfTipologia.find(
      (element) => element.id === data.tipologiaStrumentazioneId,
    );
    if (stuff !== undefined) {
      return stuff.id;
    } else {
      return '';
    }
  };

  updateAttrezzaturaLocale = (data, id, index) => {
    let records = [...this.state.records];
    records[index] = data;
    records[index].tipologiaStrumentazioneId = id;
    this.setState({
      records: records,
      successfulSave: false,
    });
  };

  swapElements = (arr, i1, i2) => {
    let temp = arr[i1];

    arr[i1] = arr[i2];

    arr[i2] = temp;
  };

  moveElementUpward = (cellInfo) => {
    let array = [...this.state.records];
    if (cellInfo.index > 0) {
      this.swapElements(array, cellInfo.index, cellInfo.index - 1);
      this.setState({
        records: array,
      });
    }
  };

  moveElementDownWard = (cellInfo) => {
    let array = [...this.state.records];
    if (cellInfo.index < array.length - 1) {
      this.swapElements(array, cellInfo.index, cellInfo.index + 1);
      this.setState({
        records: array,
      });
    }
  };

  deleteElement = (cellInfo) => {
    let array = [...this.state.records];
    array.splice(cellInfo._index, 1);
    this.setState({
      records: array,
      successfulSave: false,
    });
  };

  handleNewRow = () => {
    let newRowRecords = Array.from(this.state.records);
    let newAttrezzatura = {
      id: null,
      manualeId: this.props.manualeId,
      tipologiaStrumentazioneId: null,
      localeEsercizioId: this.props.selectedLocale.id,
      nome: '',
      quantita: 0,
      indiceOrdinamento: 0,
    };
    newRowRecords.push(newAttrezzatura);

    this.setState({
      records: newRowRecords,
    });
  };

  getTipologiaStrumentazioneData = () => {
    getTipologiaStrumentazione(this.props.manualeId, 0, 1000, 'nome,ASC')
      .then((response) => {
        this.setState({
          tipologiaList: response,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  getAttrezzaturaData = () => {
    getAttrezzature(
      this.props.manualeId,
      this.props.selectedLocale.id,
      0,
      10000,
      'id',
    )
      .then((attrezzature) => {
        return getTipologiaStrumentazione(
          this.props.manualeId,
          0,
          1000,
          'nome,ASC',
        ).then((tipologie) => {
          let a = this.getAttrezzaturaColumn(attrezzature);
          this.setState({
            columns: a,
            records: attrezzature,
            tipologiaList: tipologie,
            pristineRecords: snapshotRecords(attrezzature),
          });
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  getAttrezzaturaColumn = () => {
    return [
      {
        Header: 'Tipologia',
        id: 'Tipologia',
        //width:175,
        accessor: (data) => data,
        Cell: (props) => (
          <div className={this.props.classes.centeredCellContent}>
            <Select
              variant="outlined"
              value={this.findTipologiaId(props.row.Tipologia)}
              style={{ paddingTop: 0, width: '100%' }}
              renderValue={(selected) => {
                const tipologia = this.state.tipologiaList.find(
                  (item) => item.id === selected,
                );
                return tipologia ? labelTipologia(tipologia.nome) : '';
              }}
            >
              <MenuItem
                onClick={() => {
                  this.setState({
                    openAddTipologiaModal: true,
                  });
                }}
                value={'Aggiungi Tipologia'}
              >
                {'Aggiungi Tipologia'}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.setState({
                    openRemoveTipologiaModal: true,
                    selectedTipologiaToRemove: '',
                  });
                }}
                value={'Rimuovi Tipologia'}
              >
                {'Rimuovi Tipologia'}
              </MenuItem>
              {this.state.tipologiaList.map((item) => (
                <MenuItem
                  value={item.id}
                  key={item.id}
                  onClick={() =>
                    this.updateAttrezzaturaLocale(
                      props.row.Tipologia,
                      item.id,
                      props.row._index,
                    )
                  }
                >
                  {labelTipologia(item.nome)}
                </MenuItem>
              ))}
            </Select>
          </div>
        ),
      },
      {
        Header: 'Attrezzatura',
        id: 'Attrezzatura',
        //width:175,
        accessor: (data) => data.nome,
        Cell: (props) => (
          <div className={this.props.classes.centeredCellContent}>
            <TextField
              InputProps={{ disableUnderline: true }}
              disabled={!this.state.editMode}
              onInput={(e) => {
                let attrezzaturaToChange = [...this.state.records];
                attrezzaturaToChange[props.row._index].nome = e.target.value;
                props.row.Attrezzatura = e.target.value;
                const caret = e.target.selectionStart;
                const element = e.target;
                window.requestAnimationFrame(() => {
                  element.selectionStart = caret;
                  element.selectionEnd = caret;
                });
                this.setState({
                  records: attrezzaturaToChange,
                  successfulSave: false,
                });
              }}
              inputProps={{ min: 0, style: { textAlign: 'center' } }}
              style={{
                textAlign: 'center',
                padding: 10,
                outline: `0 solid transparent`,
              }}
              value={props.row.Attrezzatura}
            />
          </div>
        ),
      },
      {
        Header: 'Quantità',
        id: 'Quantita',
        width: 120,
        accessor: (data) => data.quantita,
        Cell: (props) => (
          <div className={this.props.classes.centeredCellContent}>
            <TextField
              disabled={!this.state.editMode}
              InputProps={{ disableUnderline: true }}
              onInput={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                e.target.value = value;
                let attrezzaturaToChange = [...this.state.records];
                attrezzaturaToChange[props.row._index].quantita =
                  e.target.value;
                props.row.Quantita = e.target.value;
                const caret = e.target.selectionStart;
                const element = e.target;
                window.requestAnimationFrame(() => {
                  element.selectionStart = caret;
                  element.selectionEnd = caret;
                });
                this.setState({
                  records: attrezzaturaToChange,
                  successfulSave: false,
                });
              }}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              inputProps={{
                min: 0,
                style: {
                  textAlign: 'center',
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                },
              }}
              style={{
                textAlign: 'center',
                padding: 10,
                outline: `0 solid transparent`,
              }}
              value={props.row.Quantita}
            />
          </div>
        ),
      },
      {
        Header: 'Sposta',
        id: 'Posizione',
        width: 100,
        accessor: (data) => data,
        Cell: (props) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementUpward(props);
              }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementDownWard(props);
              }}
            >
              <KeyboardArrowDown />
            </IconButton>
          </div>
        ),
      },
      {
        Header: 'Elimina',
        id: 'Elimina',
        width: 100,
        accessor: (data) => data,
        Cell: (props) => (
          <div className={this.props.classes.centeredCellContent}>
            <IconButton onClick={() => this.deleteElement(props.row)}>
              <DeleteForeverOutlined color="primary" />
            </IconButton>
          </div>
        ),
      },
    ];
  };

  onAddTipologiaModalClose = () => {
    this.setState({
      openAddTipologiaModal: false,
      newTipologia: '',
    });
  };

  onRemoveTipologiaModalClose = () => {
    this.setState({
      openRemoveTipologiaModal: false,
    });
  };

  handleInputChangeNewTipologia = (e) => {
    this.setState({ newTipologia: e.target.value });
  };

  handleInputChangeRemoveTipologia = (e) => {
    this.setState({ selectedTipologiaToRemove: e.target.value });
  };

  handleNewTipologia = (newTipologia) => {
    let bodyToPass = {
      id: null,
      nome: newTipologia,
      manualeId: this.props.manualeId,
    };
    addNewTipologiaStrumentazione(bodyToPass)
      .then((response) => {
        this.getTipologiaStrumentazioneData();
        this.onAddTipologiaModalClose();
      })
      .catch((error) => {
        if (error.status === 409) {
          reportError(
            'Esiste già una tipologia di strumentazione con nome ' +
              newTipologia +
              ' nel manuale indicato',
          );
        } else {
          reportApiError(error);
        }
      });
  };

  handleRemoveTipologia = (tipologiaToErase) => {
    deleteTipologiaStrumentazione(tipologiaToErase)
      .then((response) => {
        this.getTipologiaStrumentazioneData();
        this.setState(
          {
            selectedTipologiaToRemove: null,
          },
          this.onRemoveTipologiaModalClose(),
        );
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <Modal
          className={classes.modal}
          open={this.props.open}
          onClose={() => {
            if (!this.state.isButtonRequestPressed) {
              this.requestClose();
            }
          }}
        >
          {this.state.isButtonRequestPressed ? (
            <SpinnerComponent size={32} />
          ) : (
            <div className={classes.modalContainer}>
              <Typography variant="h5" className={classes.modalTitle}>
                Elenco attrezzature del locale{' '}
                <span className={classes.spanTitle}>
                  {this.props.selectedLocale.nome}
                </span>
              </Typography>
              {this.state.successfulSave && (
                <Typography style={{ color: 'green' }}>
                  Attrezzature salvate con successo
                </Typography>
              )}
              <div className={classes.topButtonWrapper}>
                <Fab
                  color="primary"
                  size="small"
                  onClick={this.handleNewRow}
                  title="Aggiungi riga"
                >
                  <Add />
                </Fab>
                <Button
                  type="button"
                  onClick={() =>
                    this.setState((prevState) => ({
                      editMode: !prevState.editMode,
                    }))
                  }
                  variant="contained"
                  style={{
                    color: this.state.editMode
                      ? 'white'
                      : this.props.theme.palette.text.main,
                    margin: '10px',
                    backgroundColor: this.state.editMode
                      ? 'green'
                      : this.props.theme.palette.primary.main,
                  }}
                >
                  {this.state.editMode ? (
                    <>
                      <Done fontSize="small" style={{ marginRight: 5 }} />
                      Done
                    </>
                  ) : (
                    <>
                      <Edit fontSize="small" style={{ marginRight: 14 }} />
                      Edit
                    </>
                  )}
                </Button>
              </div>
              <ReactTable
                filterable={true}
                resizable={true}
                enableEditing={true}
                showPageSizeOptions={false}
                showPageJump={true}
                defaultPageSize={10}
                style={{
                  height: 400,
                  width: '90%',
                }}
                //pages={this.state.pages}
                data={this.state.records}
                columns={this.state.columns}
                //manual // informs React Table that you'll be handling sorting and pagination server-side
                //onFetchData={ (state, instance) => { this.fetchData(state.page, state.pageSize) } }
                previousText="Precedente"
                nextText="Successivo"
                noDataText="Nessun record"
                pageText="Pagina"
                ofText="di"
                rowsText="righe"
                pageJumpText="Vai a pagina"
                rowsSelectorText="righe per pagina"
              />
              <div className={classes.buttonWrapper}>
                <ActionButton
                  disabled={false}
                  grayVersion={false}
                  secondaryButton
                  label="Chiudi"
                  onClick={this.requestClose}
                />
                <ActionButton
                  disabled={this.state.isButtonRequestPressed}
                  grayVersion={false}
                  label="Salva"
                  onClick={this.saveData}
                />
              </div>
            </div>
          )}
        </Modal>
        {this.state.openAddTipologiaModal && (
          <TipologiaStrumentazioneModal
            description="Nuova tipologia: "
            inputValue={this.state.newTipologia}
            onClose={this.onAddTipologiaModalClose}
            onInputChange={this.handleInputChangeNewTipologia}
            onSave={this.handleNewTipologia}
            open={this.state.openAddTipologiaModal}
            title="Aggiungi tipologia di strumentazione"
          />
        )}
        {this.state.openRemoveTipologiaModal && (
          <TipologiaStrumentazioneModal
            description="Selezionare tipologia da rimuovere: "
            inputValue={this.state.selectedTipologiaToRemove || ''}
            onClose={this.onRemoveTipologiaModalClose}
            onInputChange={this.handleInputChangeRemoveTipologia}
            onSave={this.handleRemoveTipologia}
            open={this.state.openRemoveTipologiaModal}
            title="Rimuovi tipologia di strumentazione"
            selectOption={this.state.tipologiaList}
            isSelect={true}
          />
        )}
        {/* Sibling of the Modal rather than a child: the isButtonRequestPressed
            spinner branch replaces the Modal's children and would unmount it. */}
        <TwoActionsAlertDialog
          visible={this.state.isCloseConfirmOpen}
          title="Attenzione"
          message={UNSAVED_CHANGES_CLOSE_MESSAGE}
          onOkClicked={this.confirmDiscardAndClose}
          onIndietroClicked={this.cancelClose}
        />
      </>
    );
  }
}

ModalSelezioneAttrezzatura.propTypes = {
  classes: PropTypes.object.isRequired,
  manualeId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedLocale: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(ModalSelezioneAttrezzatura);
